import React, { useMemo } from 'react'
import { GroupContainer } from '../GroupContainer'
import { useTranslation } from '../../../../../utils/convergence'
import { useSummaryDetailsViewModel } from '../../../hooks/useSummaryDetailsViewModel'
import { Money } from '@afterpay/types'
import { ItemType } from '@afterpaytouch/portal-api'
import { SummaryItem } from '../SummaryItem/SummaryItem'
import { Divider } from '@afterpaytouch/core'

export type DueTodayItem = {
  id: string
  name: string
  amount: Money
}

export const DueTodaySection = (): JSX.Element => {
  const { t } = useTranslation()
  const { totalDueTodayAmount, payInFullItems, shippingAmount, downPaymentAmount, financedItems } = useSummaryDetailsViewModel()

  const dueTodayItems = useMemo<DueTodayItem[]>(() => {
    const items: DueTodayItem[] = []

    if (downPaymentAmount && parseFloat(downPaymentAmount.amount) > 0) {
      items.push({
        id: 'downpayment',
        name: t('summary:downPayment'),
        amount: downPaymentAmount,
      })
    }

    payInFullItems.forEach((item) => {
      if (item.type === ItemType.SHIPPING) {
        items.push({
          id: item.id,
          name: t('summary:shippingFee'),
          amount: item.price,
        })
      } else {
        items.push({
          id: item.id,
          name: item.name,
          amount: item.price,
        })
      }
    })

    return items
  }, [payInFullItems, shippingAmount, downPaymentAmount])

  const isExpandable = dueTodayItems.length >= 2

  const children = dueTodayItems.map((item, index) => (
    <SummaryItem key={item.id} id={item.id} index={index} name={item.name} amount={item.amount} testNameSpace='due-today' />
  ))

  if (dueTodayItems.length > 0) {
    children.push(
      <SummaryItem key='total-due-today' id='total-due-today' bold name={t('summary:totalDueNow')} amount={totalDueTodayAmount} testNameSpace='due-today' />
    )
  }

  const topMargin = financedItems.length > 1 ? 'No' : 'Regular'
  const bottomMargin = dueTodayItems.length > 1 ? 'No' : 'Regular'

  return (
    <>
      <Divider margin={{ top: topMargin, bottom: bottomMargin }} />
      <GroupContainer name={t('summary:dueNow')} amount={totalDueTodayAmount} expandable={isExpandable} testNameSpace='due-today'>
        {children}
      </GroupContainer>
    </>
  )
}
